import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { CardTableHeader } from '../card-table/models/card-table-header.model';
import { forkJoin } from 'rxjs';
import { PaginationService } from 'libs/portal/src/services/pagination/pagination.service';
import { CardTableOptions } from '../card-table/models/card-table-options.model';
import { ScreenSize } from 'libs/portal/src/layout/layout.service';

@Component({
  selector: 'app-show-config-modal',
  templateUrl: './show-config-modal.component.html',
  styleUrls: ['./show-config-modal.component.scss'],
})
export class ShowConfigModalComponent implements OnInit {
  constructor(
    private genericService: GenericService,
    private endpoints: Endpoints,
    private paginationService: PaginationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ShowConfigModalComponent>,
  ) {}

  server: any;
  currentPage = 0;

  resultsHeaders: CardTableHeader[] = [
    {
      ID: 'Name',
      Index: 0,
      Sort: 'Name',
      Sortable: false,
      Width: 20,
      Text: 'Name',
      Align: 'left',
    },
    {
      ID: 'ConnTimeout',
      Index: 1,
      Sort: 'ConnTimeout',
      Width: 10,
      Sortable: false,
      Text: 'Connection Timeout',
      Align: 'left',
    },
    {
      ID: 'DialTimeout',
      Index: 2,
      Sort: 'DialTimeout',
      Width: 10,
      Sortable: false,
      Text: 'Dial Timeout',
      Align: 'left',
    },
    {
      ID: 'ServerType',
      Index: 2,
      Sort: 'ServerType',
      Width: 15,
      Sortable: false,
      Text: 'Server Type',
      Align: 'left',
    },
    {
      ID: 'TLSEnable',
      Index: 2,
      Sort: 'TLSEnable',
      Width: 10,
      Sortable: false,
      Text: 'TLS Enabled',
      Align: 'left',
    },
    {
      ID: 'OLName',
      Index: 2,
      Sort: 'OLName',
      Width: 15,
      Sortable: false,
      Text: 'Outgoing Link',
      Align: 'left',
    },
    {
      ID: 'OLPort',
      Index: 2,
      Sort: 'OLPort',
      Width: 15,
      Sortable: false,
      Text: 'Outgoing Port',
      Align: 'left',
    },
  ];

  options: CardTableOptions = {
    titleProperty: 'Name',
    rowId: 'ID',
    subTitleProperty: 'data',
    additionalProperty: 'status',
    indicatorColorProperty: 'color',
    selectedProperty: 'selected',
    isSelectable: false,
    flexCardLayout: false,
    propertyRowExclusions: ['ID', 'Description'],
    stylePropertyPrefix: 'alerts',
    clickableFlexCard: false,
    textSize: 'regular',
  };

  ScreenSize = ScreenSize;

  serverLinkData: any = [];

  ngOnInit(): void {
    console.log(this.data);

    let ep1 = this.genericService.POST(this.endpoints.GET_SERVER_CONFIG, this.data);
    let ep2 = this.genericService.GET(this.endpoints.GET_SERVER_LINKS(this.data.ServerID, this.data.ServerLinkID ?? 0));
    forkJoin([ep1, ep2]).subscribe(([serverData, severLinkData]) => {
      this.server = serverData['body'];
      let tempServerLinkData = severLinkData['body'];
      console.log(tempServerLinkData);

      tempServerLinkData.forEach((link) => {
        Object.entries(link.OutgoingLinks).forEach(([key, value]) => {
          let temp = value as any;
          this.serverLinkData.push({
            Name: link.Name,
            ConnTimeout: link.ConnTimeout,
            DialTimeout: link.DialTimeout,
            ServerType: link.ServerType,
            TLSEnable: link.TLSEnable,
            OLName: temp.Name,
            OLPort: temp.Port,
          });
        });
      });
      console.log(this.serverLinkData);
    });
  }

  closeModal() {
    this.dialogRef.close();
  }

  onPageChange(event: any) {
    console.log(event);
    this.currentPage = event;
    const startIndex = (this.currentPage - 1) * 10;
    let endIndex = startIndex + 10;
    if (endIndex > this.serverLinkData.length) {
      endIndex = this.serverLinkData.length;
    }
    // this.reportResults = this.apns.slice(startIndex, endIndex);
    setTimeout(() => {
      this.paginationService.emit();
    });

    // console.log(this.dataToShow);
  }
}
